<template>

    <form @submit.prevent="form.post(route('messages.submit'))">

        <template v-if="!recipient">
            <multi-select-input
                v-model="form.recipients" 
                :multiple="true" 
                :async="true"
                :load-options="loadRecipients" 
                :placeholder="__('Search')" 
                :label="__('Recipients')"
                :error="form.errors.recipients"
                />
        </template>

        <text-input :floating="true" label="subject" v-model="form.subject" :error="form.errors.subject" />

        <textarea-input :floating="true" label="text" v-model="form.text" :error="form.errors.text" class-name="size-medium" />

        <div class="mb-3">
            <span class="d-inline-block fs-4 symbol" 
                  v-for="emoticon in emoticons" 
                  v-html="emoticon.html" 
                  :title="emoticon.desc" 
                  @click="insertSymbol(emoticon.code)">
            </span>
        </div>

        <submit-button label="send" />

    </form>

</template>


<style scoped>
    .symbol {
        cursor: pointer;
        transition: transform .3s ease;
    }
    .symbol:hover {
        transform: scale(1.15);
    }
</style>


<script>

    import TextInput from '@/shared/Inputs/TextInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';
    import MultiSelectInput from '@/shared/Inputs/MultiSelectInput';

    export default {
        props: {
            emoticons: {
                type: Array,
            },
            recipient: {
                default: null,
            },
            subject: {
                default: '',
            },
            text: {
                default: '',
            },
        },
        data() {
            return {
                form: this.$inertia.form({
                    recipients: this.recipient,
                    subject: this.subject,
                    text: this.text,
                }),
            }
        },
        components: {
            TextInput,
            TextareaInput,
            SubmitButton,
            MultiSelectInput,
        },
        watch: {

        },
        methods: {
            loadRecipients( { action, searchQuery, callback }) {
                axios.get(this.route('messages.search', {type: 'suppliers'}), {params: {search: searchQuery}})
                        .then(response => callback(null, response.data));
            },
            insertSymbol(symbol) {
                this.form.text += symbol;
            },
        },
    }
</script>